import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import { CHECKBOX_SIZE_PX, CheckboxSize } from './consts'

export const LabelWrapper = styled.label<{
  $isDisabled: boolean
}>`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      cursor: default;
      pointer-events: none;
      opacity: 0.6;
    `}
`

export const HiddenCheckbox = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  pointer-events: none;
`

export const Box = styled.span<{
  $isChecked: boolean
  $isDisabled: boolean
  $size: CheckboxSize
}>`
  --size: ${({ $size }) => `${CHECKBOX_SIZE_PX[$size]}px`};
  position: relative;
  width: var(--size);
  height: var(--size);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid ${COLORS.borderColor};
  border-radius: 4px;
  background: ${COLORS.white};
  transition: all 0.15s ease-in-out;

  ${({ $isChecked }) =>
    $isChecked &&
    css`
      border-color: ${COLORS.primaryDark};
      background: ${COLORS.primaryDark};
    `}

  path {
    fill: ${COLORS.white};
  }
`
